import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { ModalReact, ModalType } from "common/components/modal";
import { SvgIconReact } from "common/components/svg-icon";
import { ButtonReact } from "common/components/button";
import { ButtonTheme, ButtonType } from "common/components/button/constants";
import { trackUpsellEvent, UpsellType } from "common/report/util/tracking-helpers";
import { getUpsellInfo } from "common/widgets/in-product-upsell-modal/util";
import { ModelStatus } from "common/util/model-resource/model-resource";
import { useCurrentProject } from "common/contexts/react/current-project-context";
import { useThemes } from "common/contexts/react/themes-context";
import { useTranslation } from "common/i18n/hooks";
import styles from "./index.module.styl";
const OLD_PLAN_BUILDER_LINK = "/pricing/plan-builder/";
const MODAL_VERSION = "v2";
const UPSELL_TYPE_TO_TEXT = {
  [UpsellType.FREE_TO_GROWTH]: {
    ctaText: (_ref) => {
      let {
        t
      } = _ref;
      return t("upsells.modal.free-to-growth-cta");
    },
    ctaUpgradeLink: OLD_PLAN_BUILDER_LINK,
    ctaExitText: (_ref2) => {
      let {
        t
      } = _ref2;
      return t("upsells.modal.free-to-growth-cta-exit");
    }
  },
  [UpsellType.GROWTH_TO_ENTERPRISE]: {
    ctaText: (_ref3) => {
      let {
        t
      } = _ref3;
      return t("upsells.modal.growth-to-enterprise-cta");
    },
    ctaUpgradeLink: "/contact-us/sales/",
    ctaExitText: (_ref4) => {
      let {
        t
      } = _ref4;
      return t("upsells.modal.growth-to-enterprise-cta-exit");
    }
  },
  // Default unknown to growth values
  [UpsellType.UNKNOWN]: {
    ctaText: (_ref5) => {
      let {
        t
      } = _ref5;
      return t("upsells.modal.free-to-growth-cta");
    },
    ctaUpgradeLink: OLD_PLAN_BUILDER_LINK,
    ctaExitText: (_ref6) => {
      let {
        t
      } = _ref6;
      return t("upsells.modal.free-to-growth-cta-exit");
    }
  }
};
export function template(_ref7) {
  let {
    modalTrigger,
    open,
    closeModal,
    metadata = {}
  } = _ref7;
  const currentProject = useCurrentProject();
  const [upsellInfo, setUpsellInfo] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const themesResource = useThemes();
  const isDarkMode = themesResource.isDarkMode();
  const i18n = useTranslation();
  const {
    print,
    t
  } = i18n;
  useEffect(() => {
    const model = currentProject === null || currentProject === void 0 ? void 0 : currentProject.get();
    if ((model === null || model === void 0 ? void 0 : model.status) === ModelStatus.Success && model.value) {
      const tmpInfo = getUpsellInfo(model.value, modalTrigger, i18n, metadata);
      if (tmpInfo) {
        setUpsellInfo(tmpInfo);
        setOrgId(model.value.organizationId);
        if (open) {
          trackUpsellEvent("Upsell Modal Shown", tmpInfo === null || tmpInfo === void 0 ? void 0 : tmpInfo.trackingFeatureGate, {
            version: MODAL_VERSION,
            upsellType: tmpInfo === null || tmpInfo === void 0 ? void 0 : tmpInfo.upsellType
          });
          trackUpsellEvent("View Upsell", tmpInfo === null || tmpInfo === void 0 ? void 0 : tmpInfo.trackingFeatureGate, {
            version: MODAL_VERSION,
            upsellType: tmpInfo === null || tmpInfo === void 0 ? void 0 : tmpInfo.upsellType
          });
        }
      }
    }
  }, [open, currentProject]);
  const handleClickUpgrade = () => {
    if (!upsellInfo) {
      return;
    }
    trackUpsellEvent("Click Upsell", upsellInfo.trackingFeatureGate, {
      version: MODAL_VERSION,
      upsellType: upsellInfo.upsellType
    });
  };
  const handleClose = () => {
    if (upsellInfo) {
      trackUpsellEvent("Dismiss Upsell", upsellInfo.trackingFeatureGate, {
        version: MODAL_VERSION,
        upsellType: upsellInfo.upsellType
      });
    }
    closeModal();
  };
  const GrowthGridItems = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-bar-chart", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.reports-and-cohorts")), /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-gem", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.spark")), /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-lock", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.sharing")), /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-laptop", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.email-and-slack")));
  const EnterpriseGridItems = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-eye", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.session-replay")), /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-clipboard", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.data-governance")), /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-plug", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.data-warehouse-ingestion")), /* @__PURE__ */ React.createElement("div", { className: styles.gridItem }, /* @__PURE__ */ React.createElement(SvgIconReact, { icon: "brand-hand-holding-heart", "data-sentry-element": "SvgIconReact", "data-sentry-source-file": "template.tsx" }), t("upsells.modal.premium-support")));
  let upsellLink = "";
  if (upsellInfo) {
    if (UPSELL_TYPE_TO_TEXT[upsellInfo.upsellType].ctaUpgradeLink === OLD_PLAN_BUILDER_LINK) {
      upsellLink = "/settings/org/".concat(orgId, "/plan?show-modal=plan-builder");
    } else {
      upsellLink = "".concat(UPSELL_TYPE_TO_TEXT[upsellInfo.upsellType].ctaUpgradeLink, "?org=").concat(orgId);
    }
  }
  return upsellInfo ? /* @__PURE__ */ React.createElement(ModalReact, { className: styles.modalContainer, open, modalTitle: upsellInfo === null || upsellInfo === void 0 ? void 0 : upsellInfo.title, modalDescription: upsellInfo === null || upsellInfo === void 0 ? void 0 : upsellInfo.description, modalType: ModalType.Modal, "data-sentry-element": "ModalReact", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement("div", { className: styles.modalBody }, /* @__PURE__ */ React.createElement("p", { className: styles.modalTitle }, upsellInfo === null || upsellInfo === void 0 ? void 0 : upsellInfo.title), /* @__PURE__ */ React.createElement("p", { className: styles.modalDescription }, upsellInfo === null || upsellInfo === void 0 ? void 0 : upsellInfo.description), /* @__PURE__ */ React.createElement("div", { className: clsx(styles.gridContainer, styles.spacedTop) }, upsellInfo.upsellType === UpsellType.GROWTH_TO_ENTERPRISE ? /* @__PURE__ */ React.createElement(EnterpriseGridItems, null) : /* @__PURE__ */ React.createElement(GrowthGridItems, null)), /* @__PURE__ */ React.createElement("div", { className: styles.spacedTop }, /* @__PURE__ */ React.createElement(ButtonReact, { className: clsx(styles.ctaButton, {
    [styles.darkMode]: isDarkMode
  }), theme: ButtonTheme.Tertiary, type: ButtonType.Info, href: upsellLink, notFocusable: true, onClick: handleClickUpgrade, "data-sentry-element": "ButtonReact", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement("div", { className: styles.ctaText }, upsellInfo ? print(UPSELL_TYPE_TO_TEXT[upsellInfo.upsellType].ctaText) : "")), /* @__PURE__ */ React.createElement(ButtonReact, { className: clsx(styles.ctaTextButton, {
    [styles.darkMode]: isDarkMode
  }), theme: ButtonTheme.Tertiary, notFocusable: true, onClick: handleClose, "data-sentry-element": "ButtonReact", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement("div", null, upsellInfo ? print(UPSELL_TYPE_TO_TEXT[upsellInfo.upsellType].ctaExitText) : ""))))) : null;
}
